import { render, staticRenderFns } from "./WorkflowListPage.vue?vue&type=template&id=79f3bf38&"
import script from "./WorkflowListPage.vue?vue&type=script&lang=ts&"
export * from "./WorkflowListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports